// 네이티브 셸 앱(2.2.7 이상) 여부 판정.
// 2.2.6 이하는 자체 하단 네비게이션이 없어 웹 GNB 가 필요하고,
// openNativeScreen 등 브릿지 핸들러도 없어 호출이 무시된다.

/** 네이티브 셸 전환 최소 버전 */
const MIN_NATIVE_SHELL_VERSION = [2, 2, 7]

/** UA 에서 APP_USIMSA/x.y.z 파싱. 없으면 null */
const parseAppVersion = (ua: string): number[] | null => {
  const matched = ua.match(/APP_USIMSA\/(\d+)\.(\d+)\.(\d+)/)
  if (!matched) return null

  return [Number(matched[1]), Number(matched[2]), Number(matched[3])]
}

/** [major, minor, patch] 정수 비교. 문자열 비교 금지 — '2.2.10' 오판 */
const isVersionGte = (version: number[], min: number[]): boolean => {
  for (let i = 0; i < min.length; i += 1) {
    if (version[i] > min[i]) return true
    if (version[i] < min[i]) return false
  }

  return true
}

/**
 * UA가 앱이면서 2.2.7 이상이면 true.
 * 일반 브라우저 / 2.2.6 이하 / UA 에 버전 없음 → 모두 false.
 *
 * SSR에서도 판정할 수 있도록 브라우저 전역 객체를 참조하지 않는다.
 */
export const isNativeShellAppUA = (ua: string): boolean => {
  const version = parseAppVersion(ua)
  if (!version) return false

  return isVersionGte(version, MIN_NATIVE_SHELL_VERSION)
}

/**
 * 앱이면서 2.2.7 이상이면 true.
 * 일반 브라우저 / SSR / 2.2.6 이하 / UA 에 버전 없음 → 모두 false.
 */
export const isNativeShellApp = (): boolean => {
  if (typeof window === 'undefined') return false
  if (!window.flutter_inappwebview) return false

  // 앱이 주입하는 버전 플래그 우선, 없으면 UA 파싱
  const injected = window.__usimsaAppVersion
  const userAgent = injected ? `APP_USIMSA/${injected}` : navigator.userAgent

  return isNativeShellAppUA(userAgent)
}
